import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The &nbsp;International &nbsp;Renewable Energy Agency (IRENA)
              indicates that by &nbsp;2030 biomass would comprise 20% of the
              global primary energy &nbsp;supply, &nbsp;doubling &nbsp;its&nbsp;
              &nbsp;share &nbsp;from &nbsp;10% &nbsp;in&nbsp; &nbsp;2010
              &nbsp;(IRENA, 2015). The prospect of agro-residue as prominent
              global bioenergy provider is also &nbsp;very &nbsp;high in
              &nbsp;the near future. Global agro-residue availability is
              &nbsp;estimated to &nbsp;be &nbsp;3.6&ndash;17.2 billion tonnes
              with an equivalent energy potential of 13.1&ndash;122 EJ (WBA,
              2015). Some &nbsp;dis- tinct advantages of agro-residue as energy
              source are: (i) suitable feedstock for&nbsp; heat and power and
              transportation fuel &nbsp;production, (ii) generation of wide
              range of by-products with potential for fur- ther valorization
              through the biorefinery process, (iii) &nbsp;a &nbsp;carbon
              neutral or low carbon fuel that emits less carbon dioxide than
              fossil fuels in its life cycle, &nbsp;(iv) scope for development
              of bioenergy based entrepreneurial &nbsp;activities, (v)
              &nbsp;feasibility of&nbsp; generating decentral- ized &nbsp;mode
              of energy to &nbsp;empower remote areas.
            </p>
            <p>
              Agro-residues are &nbsp;geographically distributed with variation
              in spatio-temporal availability. For viable commissioning of
              biomass power plant, prior and precise database of&nbsp; residue
              distribution, seasonal fluctuation (peak and lean period of
              &nbsp;availability) is &nbsp;a pre-requisite. Logistics such as
              residue harvest, collection, storage, transportation are
              &nbsp;spatially interlinked and need meticulous plan- ning.
              Adequacy, precision, reliability of data collected through tra-
              ditional &nbsp;methods&nbsp; &nbsp;(survey
              &nbsp;or&nbsp;&nbsp;&nbsp; secondary&nbsp; &nbsp;data&nbsp;
              &nbsp;collection) &nbsp;for bioenergy planning is &nbsp;a
              &nbsp;matter of &nbsp;question, which often lead to over
              &nbsp;or&nbsp; under estimation of potentially accessible energy
              source. Therefore, energy and environmental &nbsp;assessment
              &nbsp;need decision support &nbsp;system &nbsp;(DSS)&nbsp;&nbsp;
              for&nbsp; &nbsp;effective &nbsp;planning &nbsp;(Sacchelli et
              &nbsp;al.,2013). Spatial tools are &nbsp;able&nbsp;&nbsp; to
              &nbsp;relate large scale environmental assessment with medium and
              small scale DSS, useful for &nbsp;decision makers. Geographical
              Information&nbsp; System (GIS) &nbsp;is &nbsp;an &nbsp;important
              decision making spatial tool &nbsp;which aids &nbsp;precise
              assessment of dis- tributed &nbsp;renewable &nbsp;energy&nbsp;
              resources &nbsp;(Yue&nbsp; &nbsp;and &nbsp;Wang, 2006;
              Angelis-Dimakis et al., &nbsp;2011; Ramachandra et al.,
              &nbsp;2005). Review of the potential applications of GIS in
              agro-residue bioenergy plan- ning is one &nbsp;of the objectives
              of this paper.
            </p>
            <p>
              The climate change mitigation benefit of bioenergy has
              &nbsp;become a &nbsp;much debatable issue in &nbsp;recent times
              because of&nbsp; the limited information &nbsp;on&nbsp; &nbsp;the
              &nbsp;direct &nbsp;and &nbsp;indirect&nbsp; environmental&nbsp;
              conse- quences of bioenergy. It is&nbsp; expressed that
              unsustainable produc- tion or &nbsp;over-exploitation of&nbsp;
              bioenergy feedstock may exacerbate greenhouse gas emissions and
              jeopardize many ecosystem services (Fargione et al., &nbsp;2008;
              Searchinger et al., &nbsp;2008; Danielsen et al.,2009; Lapola
              &nbsp;et al., 2010; Liska et al., 2014). Large scale cultivation
              of&nbsp; bioenergy crops can &nbsp;lead to &nbsp;the so-called
              food &nbsp;vs. fuel &nbsp;debate (Tilman et al., 2009). Loss of
              carbon pools and carbon sequestration dynamics may occur from
              the&nbsp; conversion of &nbsp;land to &nbsp;bioenergy cropland,
              which can &nbsp;only &nbsp;be &nbsp;balanced by&nbsp; bioenergy
              crops in hun- dreds of years (Gibbs et al., 2008). In this regard,
              Life Cycle Assess- ment (LCA) based investigation of possible
              environmental implications of &nbsp;bioenergy production is
              &nbsp;critical to &nbsp;avoid decline of existing carbon stocks
              (Cherubini et al., 2009). A review of the applications of LCA in
              agro-residue bioenergy is another objective of this paper. GIS and
              LCA differs from each other in the sense that, the former is used
              for spatial data acquisition, storage, processing and visual-
              ization, while LCA is not, &nbsp;but they are complementary to
              each other(Gorniak-Zimroz and Pactwa, 2015). Certain impacts of
              bioenergy (e.g. impact on &nbsp;biodiversity) are &nbsp;spatially
              allocated due to &nbsp;the dis- tributed nature of biomass
              feedstocks. Current LCA measures are inadequate to &nbsp;spatially
              account such impacts. The &nbsp;integrated use of GIS and LCA
              (hereafter termed as spatial LCA) could address such issues by
              allocating the impacts into spatial units (Bengtsson et al.,
              <br />
              1998; Geyer et al., &nbsp;2010; Gasol &nbsp;et al., &nbsp;2011;
              Gorniak-Zimroz and Pactwa, 2015). Spatial LCA is &nbsp;an
              &nbsp;emerging research field &nbsp;and the discussion of current
              development in&nbsp; this field &nbsp;is also &nbsp;one &nbsp;of
              the objectives of the paper.
            </p>
            <p>
              In line &nbsp;with the above discussion, the present paper reviews
              the potential applications of &nbsp;GIS, LCA and spatial LCA in
              &nbsp;sustainable planning of residue-based bioenergy program. The
              review includes a discussion on the role&nbsp; of GIS in biomass
              resource assessment, bio- mass logistics planning and bioenergy
              power plant&nbsp; design. The review also &nbsp;highlights the
              application of LCA in evaluation of envi- ronmental performance of
              &nbsp;agro-residue &nbsp;bioenergy systems.&nbsp; The
              uncertainties associated with LCA study and measures to
              &nbsp;address them are also reviewed. Further, the importance and
              potential ben- efits &nbsp;of integrating GIS into LCA platform
              (spatial LCA) for &nbsp;bioen- ergy &nbsp;planning are &nbsp;also
              &nbsp;reviewed. &nbsp;It is &nbsp;expected that, analysis of the
              aspects about the significance and practical relevance of GIS, LCA
              and spatial LCA tool &nbsp;covered in &nbsp;this study will
              &nbsp;be &nbsp;helpful in making informed decisions about future
              directions for&nbsp; bioenergy planning, research and development.
            </p>

            <p>
              <strong>KEYWORDS</strong>:&nbsp;Macrophytes, Bengaluru, Jakkur
              Lake, Heavy metal
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
